<template>
  <div>
    <form
      class="row block"
      v-on:submit.prevent="findParcelshops"
      autocomplete="on"
    >
      <div
        class="col-xs-4 col-md-3 col-lg-3 zipcode-input d-flex align-items-center"
      >
        <div class="ot__input__accessibility">
          <label
            for="zipCode"
            :class="{
              'MR-theme': !isIberian,
            }"
            >{{ $t("parcelshopPicker.form.zipCode") }} :
          </label>
          <input
            :class="{
              'green-bar': isZipCodeValid,
              'red-bar': zipCode && !isZipCodeValid,
            }"
            name="zipCode"
            id="zipCode"
            type="text"
            v-model="zipCode"
            @blur="hideSuggestions"
            autocomplete="none"
            placeholder=""
            aria-describedby="zipCode-error"
          />
          <div
            role="alert"
            aria-live="assertive"
            id="zipCode-error"
            style="display: none; color: red"
          >
            {{ $t("parcelshopPicker.form.zipcodeErrorMsg") }}
          </div>
        </div>
        <ul
          class="suggestions ui-menu ui-widget ui-widget-content ui-corner-all"
          v-if="
            !isSuggestionsHidden &&
            zipCode &&
            isZipCodeValid &&
            autocomplete.type === 'zipCode' &&
            autocomplete.suggestions.length > 0
          "
        >
          <li
            class="ui-menu-item"
            v-for="(suggestion, index) in autocomplete.suggestions"
            :key="index"
            @mousedown.prevent="selectSuggestion(suggestion)"
          >
            {{ suggestion.label }}
          </li>
        </ul>
      </div>
      <div
        class="col-xs-4 col-md-3 col-lg-4 city-input d-flex align-items-center"
      >
        <div class="ot__input__accessibility">
          <label
            :class="{
              'MR-theme': !isIberian,
            }"
            for="city"
            >{{ $t("parcelshopPicker.form.city") }} :
          </label>
          <input
            :class="{
              'green-bar': isCityValid,
              'red-bar': city && !isCityValid,
            }"
            name="city"
            id="city"
            type="text"
            v-model="city"
            @blur="hideSuggestions"
            autocomplete="none"
            placeholder=""
            aria-describedby="city-error"
          />
          <div
            role="alert"
            aria-live="assertive"
            id="city-error"
            style="display: none; color: red"
          >
            {{ $t("parcelshopPicker.form.cityErrorMsg") }}
          </div>
        </div>
        <ul
          class="suggestions ui-menu ui-widget ui-widget-content ui-corner-all"
          v-if="
            !isSuggestionsHidden &&
            city &&
            isCityValid &&
            autocomplete.type === 'city' &&
            autocomplete.suggestions.length > 0
          "
        >
          <li
            class="ui-menu-item"
            v-for="(suggestion, index) in autocomplete.suggestions"
            :key="index"
            @mousedown.prevent="selectSuggestion(suggestion)"
          >
            {{ suggestion.label }}
          </li>
        </ul>
      </div>
      <div class="col-xs-9 mobile-input d-flex align-items-center">
        <!-- <label class="mobile-label" for="cityOrZipCode">{{ $t("parcelshopPicker.form.cityOrZipCode") }} :</label> -->
        <input
          :class="{
            'green-bar': isCityOrZipCodeValid,
            'red-bar': cityOrZipCode && !isCityOrZipCodeValid,
          }"
          name="cityOrZipCode"
          id="cityOrZipCode"
          type="text"
          v-model="cityOrZipCode"
          autocomplete="none"
          :placeholder="$t('parcelshopPicker.form.cityOrZipCode')"
        />
        <ul
          class="suggestions ui-menu ui-widget ui-widget-content ui-corner-all"
          v-if="
            !isSuggestionsHidden &&
            cityOrZipCode &&
            isCityOrZipCodeValid &&
            autocomplete.type === 'mobile' &&
            autocomplete.suggestions.length > 0
          "
        >
          <li
            class="ui-menu-item"
            v-for="(suggestion, index) in autocomplete.suggestions"
            :key="index"
            @mousedown.prevent="selectSuggestion(suggestion)"
          >
            {{ suggestion.label }}
          </li>
        </ul>
      </div>
      <div class="col-xs-3 col-md-2 col-lg-2">
        <div class="ot__input__accessibility">
          <label v-if="isIberian" for="countrySelect" style="left: -13px"
            >{{ $t("parcelshopPicker.form.country") }} :
          </label>
          <div class="select">
            <select
              :disabled="$store.state.isCompleterDonnees"
              v-model="userSelectedCountry"
              @change="clearPostcodeAndCity"
              class="country-select"
              id="countrySelect"
            >
              <option
                v-for="country in availableCountries"
                :key="country.id"
                :value="country.Value"
              >
                {{ country.Text }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="mobile-geolocalization">
        <a class="btn">
          <span class="icon-geo" @click="findNearestParcelshops">
            <!-- <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="25" viewBox="0 0 16 16">
                <path d="M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"></path>
            </svg> -->
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="25"
              height="25"
              viewBox="0 0 16 16"
              :aria-label="$t('parcelshopPicker.alt.target_picto')"
            >
              <path
                d="M16 7h-1.577c-0.432-2.785-2.638-4.991-5.423-5.423v-1.577h-2v1.577c-2.785 0.432-4.991 2.638-5.423 5.423h-1.577v2h1.577c0.432 2.785 2.638 4.991 5.423 5.423v1.577h2v-1.577c2.785-0.432 4.991-2.638 5.423-5.423h1.577v-2zM12.388 7h-1.559c-0.301-0.852-0.977-1.528-1.829-1.829v-1.559c1.68 0.383 3.005 1.708 3.388 3.388zM8 9c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM7 3.612v1.559c-0.852 0.301-1.528 0.977-1.829 1.829h-1.559c0.383-1.68 1.708-3.005 3.388-3.388zM3.612 9h1.559c0.301 0.852 0.977 1.528 1.829 1.829v1.559c-1.68-0.383-3.005-1.708-3.388-3.388zM9 12.388v-1.559c0.852-0.301 1.528-0.977 1.829-1.829h1.559c-0.383 1.68-1.708 3.005-3.388 3.388z"
              ></path>
            </svg>
          </span>
        </a>
      </div>
      <div class="col-xs-4 col-md-4 col-lg-3 desktop-only">
        <div class="col-md-5 submit-btn">
          <button type="submit"></button>
          <a
            id="submitBtn"
            class="btn"
            href="#"
            role="button"
            @click.prevent="findParcelshops"
            @keydown.enter.prevent="findParcelshops"
            @keydown.space.prevent="findParcelshops"
            >{{ $t("parcelshopPicker.form.find") }}</a
          >
        </div>
        <div class="col-md-7 geolocalization">
          <div
            :class="{ disabled: !isUserAllowGeolocalisation }"
            class="btn position-button"
            role="button"
            tabindex="0"
            v-popover:position.bottom
            @click.prevent="findNearestParcelshops"
            @keydown.enter.prevent="findNearestParcelshops"
            @keydown.space.prevent="findNearestParcelshops"
          >
            <div>
              {{ $t("parcelshopPicker.form.aroundMe")
              }}<!--<span class="icon-geo"></span>-->
              <!-- <svg class="icon-geo" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="17" viewBox="0 0 16 16">
                <path d="M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"></path>
              </svg> -->
              <svg
                class="icon-geo"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="27"
                height="27"
                viewBox="0 0 16 16"
                aria-hidden="true"
              >
                <path
                  d="M16 7h-1.577c-0.432-2.785-2.638-4.991-5.423-5.423v-1.577h-2v1.577c-2.785 0.432-4.991 2.638-5.423 5.423h-1.577v2h1.577c0.432 2.785 2.638 4.991 5.423 5.423v1.577h2v-1.577c2.785-0.432 4.991-2.638 5.423-5.423h1.577v-2zM12.388 7h-1.559c-0.301-0.852-0.977-1.528-1.829-1.829v-1.559c1.68 0.383 3.005 1.708 3.388 3.388zM8 9c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM7 3.612v1.559c-0.852 0.301-1.528 0.977-1.829 1.829h-1.559c0.383-1.68 1.708-3.005 3.388-3.388zM3.612 9h1.559c0.301 0.852 0.977 1.528 1.829 1.829v1.559c-1.68-0.383-3.005-1.708-3.388-3.388zM9 12.388v-1.559c0.852-0.301 1.528-0.977 1.829-1.829h1.559c-0.383 1.68-1.708 3.005-3.388 3.388z"
                ></path>
              </svg>
            </div>
          </div>
          <popover v-if="!isUserAllowGeolocalisation" name="position">
            {{ $t("parcelshopPicker.form.positionAuthorization") }}.
          </popover>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "mr-pp-form",
  data() {
    return {
      zipCode: this.postcode,
      formularZipCode: this.postcode,
      formularBookZipCode: this.postcode,
      city: this.town,
      formularCity: this.town,
      cityOrZipCode:
        this.postcode && this.town
          ? this.postcode + " - " + this.town
          : this.postcode,
      position: {},
      isSuggestionSelected: false,
      focused: "",
      isSuggestionsHidden: false,
      isSuggestionSelectionInProgress: false,
      isUserAllowGeolocalisation: true,
      searchTimeout: 0,
      isIberian: this.countryCode === "ES" || this.countryCode === "PT",
    };
  },
  props: {
    postcode: {
      type: String,
      required: false,
    },
    town: {
      type: String,
      required: false,
    },
    countryCode: {
      type: String,
      required: false,
    },
    authorizedNatures: {
      type: String,
      required: false,
    },
    loadAndSearch: {
      type: Boolean,
      required: false,
    },
  },
  watch: {
    zipCode: function (newVal) {
      this.changeValue("zipCode", newVal);
    },
    city: function (newVal) {
      this.changeValue("city", newVal);
    },
    cityOrZipCode: function (newVal) {
      this.changeValue("mobile", newVal);
    },
  },
  computed: {
    ...mapState(["availableCountries", "parcelshopList", "autocomplete"]),
    isZipCodeValid: function () {
      return this.zipCode && this.zipCode.length > 2 && !isNaN(this.zipCode[0]);
    },
    isCityValid: function () {
      return this.city && this.city.length > 2;
    },
    isCityOrZipCodeValid: function () {
      return this.cityOrZipCode && this.cityOrZipCode.length > 2;
    },
    userSelectedCountry: {
      get: function () {
        return this.$store.state.userSelectedCountry;
      },
      set: function (newSelectedCountry) {
        if (newSelectedCountry) {
          this.$store.commit("setUserSelectedCountry", newSelectedCountry);
        }
      },
    },
  },
  methods: {
    fetchCountries: function () {
      this.$store.dispatch("fetchCountries");
    },
    findParcelshops: function () {
      if (this.zipCode == null || this.city == null) {
        this.zipCode = document.querySelector("#zipCode").value;
        this.city = document.querySelector("#city").value;
      }
      this.$emit("find-button-triggered");
      this.$store.dispatch("findParcelshops", {
        zipCode: this.zipCode,
        city: this.city,
        country: this.userSelectedCountry,
      });
    },
    closeSuggestion: function () {
      let suggestion = document.querySelector(".suggestions");
      if (suggestion) {
        suggestion.classList.add("hidden");
      } else {
        setTimeout(this.closeSuggestion, 100);
      }
    },
    /*getPostCodeForm: function (postCodeForm) {
      const self = this;
      postCodeForm.addEventListener("change", function() {
        if (postCodeForm.value != null && postCodeForm.value != undefined) {
          self.zipCode = document.querySelector("#CreerEnvoi_Destinataire_CodePostal").value
          self.city = document.querySelector("#CreerEnvoi_Destinataire_Ville").value
          self.findParcelshops()
          self.closeSuggestion()
        }
      })
    },
    triggerGetPostCodeForm: function () {
      const self = this;
      const field = document.querySelector("#label-coordonnees-destinataire")
      if (field != null && field != undefined) {
        field.addEventListener("click", function() {
          const postCodeForm = document.querySelector("#CreerEnvoi_Destinataire_CodePostal")
          if (postCodeForm != null && postCodeForm != undefined) {
            self.getPostCodeForm(postCodeForm);
          }
        })
      }
    },*/
    findNearestParcelshops: function () {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.isUserAllowGeolocalisation = true;
          this.position = position;

          this.$store.dispatch("findNearestParcelshops", {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            country: this.userSelectedCountry,
          });
          return;
        },
        () => {
          this.isUserAllowGeolocalisation = false;
        }
      );
    },
    selectSuggestion: function (suggestion) {
      this.isSuggestionSelectionInProgress = true;
      this.cityOrZipCode = suggestion.label;
      this.zipCode = suggestion.CodePostal;
      this.city = suggestion.Libelle;
      let type = this.autocomplete.type;
      setTimeout(() => {
        this.$store.commit("resetAutocomplete");
        this.isSuggestionSelectionInProgress = false;
        if (type == "mobile") {
          this.findParcelshops();
        }
      }, 50);
    },
    changeValue: function (type, value) {
      if (!this.isSuggestionSelectionInProgress) {
        this.$store.commit("resetAutocomplete");
        this.isSuggestionsHidden = false;
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
        let self = this;
        this.searchTimeout = setTimeout(() => {
          self.$store.dispatch("searchForSuggestions", { type, value });
          self.isSuggestionSelectionInProgress = false;
          clearTimeout(self.searchTimeout);
        }, 500);
      }
    },
    hideSuggestions: function () {
      setTimeout(() => {
        this.isSuggestionsHidden = true;
      }, 100);
    },
    clearPostcodeAndCity: function () {
      this.cityOrZipCode = "";
      this.zipCode = "";
      this.city = "";
    },
  },
  mounted() {
    this.hideSuggestions();
    //this.triggerGetPostCodeForm();
    setInterval(() => {
      let zipCodeOrCityChanged = false;
      const externalZipCode = document.querySelector(
        "#CreerEnvoi_Destinataire_CodePostal"
      )
        ? document.querySelector("#CreerEnvoi_Destinataire_CodePostal").value
        : null;
      if (externalZipCode && externalZipCode !== this.formularZipCode) {
        this.formularZipCode = externalZipCode;
        this.zipCode = externalZipCode;
        zipCodeOrCityChanged = true;
      }

      // Page sending parcels
      const externalCity = document.querySelector(
        "#CreerEnvoi_Destinataire_Ville"
      )
        ? document.querySelector("#CreerEnvoi_Destinataire_Ville").value
        : null;
      if (externalCity && externalCity !== this.formularCity) {
        this.formularCity = externalCity;
        this.city = externalCity;
      }

      // Page complete adress of receiver
      const externalCityReceiver = document.querySelector("#Libelle")
        ? document.querySelector("#Libelle").value
        : null;
      if (externalCityReceiver && externalCityReceiver !== this.formularCity) {
        this.formularCity = externalCityReceiver;
        this.city = externalCityReceiver;
      }

      let carnetAdresseCodePostal = document.getElementById("codePostalContact")
        ? document.getElementById("codePostalContact").value
        : null;
      if (
        carnetAdresseCodePostal &&
        carnetAdresseCodePostal !== this.formularBookZipCode
      ) {
        this.zipCode = carnetAdresseCodePostal;
        this.formularBookZipCode = carnetAdresseCodePostal;
        this.userSelectedCountry =
          document.getElementById("codePaysContact").value;
        zipCodeOrCityChanged = true;
      }

      let countrySelectValue = document.getElementById(
        "CreerEnvoi_Destinataire_Pays"
      )
        ? document.getElementById("CreerEnvoi_Destinataire_Pays").value
        : null;
      if (countrySelectValue) {
        this.userSelectedCountry = document.getElementById(
          "CreerEnvoi_Destinataire_Pays"
        ).value;
      }

      if ((this.zipCode != "" || this.city != "") && zipCodeOrCityChanged) {
        this.findParcelshops();
        this.closeSuggestion();
      }
    }, 1000);
    this.userSelectedCountry = this.countryCode || "FR";
    this.$store.dispatch("fetchCountries");
    this.$store.commit("setAuthorizedNatures", this.authorizedNatures);
    if (this.loadAndSearch && this.countryCode && this.zipCode) {
      this.findParcelshops();
    }
  },
};
</script>

<style scoped lang="scss">
.block {
  padding: 20px;
  display: flex;
  align-items: center;
  margin: 0px !important;
  max-height: 150px;
}

.zipcode-input,
.city-input,
.mobile-input {
  position: relative;
  label {
    top: -19px;
    left: 0px;
  }

  input {
    border: 1px solid #ccc;
  }

  .red-bar {
    border: 1px solid #ccc;
  }

  .green-bar {
    border: 1px solid #ccc;
  }
}

div.select {
  &::before {
    content: "";
    border: 0px;
    width: 0px;
    height: 0px;
  }

  &::after {
    content: "";
    border: 0px;
    width: 0px;
    height: 0px;
  }

  select.country-select {
    border: 1px solid #ccc;

    &::before {
      content: "";
      border: 0px;
      width: 0px;
      height: 0px;
    }

    &::after {
      content: "";
      border: 0px;
      width: 0px;
      height: 0px;
    }
  }
}

.suggestions {
  position: absolute;
  left: 16px;
  z-index: 1002;
  top: 45px;
  width: 90%;
  padding: 5px 5px;

  li {
    padding: 2px 5px;
    text-align: left;

    &:hover {
      cursor: pointer;
      background-color: #dadada;
      border: 1px solid #999999;
      border-radius: 2px;
    }
  }
}

.select select {
  margin-bottom: 0 !important;
}

.btn {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  font-family: "Montserrat", sans-serif;
  padding: 15px !important;
  line-height: 17px;
  box-shadow: none !important;
  text-align: center;
  font-size: 1.5rem;
  white-space: normal !important;
  -webkit-tap-highlight-color: transparent;
  -webkit-transition: background-color 0.3s, color 0.3s, width 0.3s,
    border-width 0.3s, border-color 0.3s;
  transition: background-color 0.3s, color 0.3s, width 0.3s, border-width 0.3s,
    border-color 0.3s;
  text-decoration: none !important;
  font-style: normal !important;
}

.position-button {
  cursor: pointer;
  width: 140px !important;
}

.icon-geo {
  margin-left: 5px;
}

[data-popover="position"] {
  font-size: 12px;
  top: 37px !important;
  left: 15px !important;
  z-index: 91 !important;
}

button[type="submit"] {
  display: none;
}

.mobile-input {
  display: none;
}

.desktop-only {
  display: block;

  .btn {
    min-width: 140px !important;
  }
}

div.desktop-only .submit-btn {
  margin-top: 16px;
  padding: 0px;
}

div.desktop-only div.geolocalization {
  padding: 0px;
  padding-left: 10px;
}
div.desktop-only div.geolocalization div.position-button {
  padding: 15px 22px 15px 0px !important;

  div {
    svg {
      position: absolute;
      margin-top: -5px;
    }
  }
}
.mobile-geolocalization {
  a.btn {
    background-color: #4dc1be;
    border-color: #4dc1be;
    border-radius: 80px;
    height: 46px;
    padding: 10px 22px 15px 22px !important;

    span.icon-geo {
      color: #fff;
      fill: #fff;
      margin-left: -12px;

      svg {
        color: #fff;
        fill: #fff;
      }
    }
  }
}

@media (max-width: 991.99px) {
  div.desktop-only div.geolocalization {
    padding-bottom: 10px;
    padding-left: 0px;
  }

  form.row.block {
    padding: 5px 20px;
  }

  div.desktop-only div.submit-btn a.btn {
    padding: 10px !important;
    margin-bottom: 15px;
  }

  div.desktop-only div.geolocalization div.position-button {
    clear: both;
    padding: 10px !important;
    margin-top: 15px;
    min-width: 110px !important;

    div {
      min-width: 110px !important;
      svg {
        position: absolute;
        margin-top: -5px;
        width: 20px;
      }
    }
  }
}

@media (min-width: 575.99px) {
  .mobile-geolocalization {
    display: none;
  }
}

@media (max-width: 575.98px) {
  .zipcode-input,
  .city-input {
    display: none;
  }

  .mobile-input {
    display: flex;
  }

  .desktop-only {
    display: none;
  }

  .mobile-label {
    padding: 0;
  }

  .zipcode-input label {
    padding: 0;
  }

  .block > div {
    padding: 0;
  }

  a.btn {
    display: none;
  }

  .mobile-geolocalization {
    position: relative;
    a.btn {
      display: block !important;
      width: 46px !important;
      position: absolute;
      top: 60px;
      right: 0;
      z-index: 999;
      span {
        line-height: 22px;
        margin: 0 5px 0 -15px;
      }
    }
  }

  .geolocalization {
    display: none;
  }

  button[type="submit"] {
    display: block;
    content: "";
    font-family: icomoon !important;
    font-size: 2.5em;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: antialiased;

    color: #fff;
    border: solid 1px #3ecf8e !important;
    background-color: #3ecf8e;

    float: right;
    border-radius: 50%;
    height: 55px;
    width: 55px;
    margin-left: 15px;

    &:before {
      content: "\e900";
    }
  }

  .suggestions {
    left: 0px;
    width: 133%;
  }
}
</style>
